module.exports = __webpack_public_path__ + "static/img/6150_phase_function_Paper_PointsHejduk_Prediction.4aaf961.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6150_phase_function_Paper_PointsHejduk_Prediction.png
// module id = kVD8
// module chunks = 0